/**
 * Created by Administrador on 13/08/2024.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .controller('takeoffCapacityCtrl', takeoffCapacityCtrl);

    takeoffCapacityCtrl.$inject = ['flightService','linkService','datePickerService','takeoffCapacityService'];

    function takeoffCapacityCtrl(flightService, linkService, datePickerService, takeoffCapacityService) {
        var vm = this;
        vm.isReport = false;
        vm.editIndexX = -1;
        vm.auxTakeoffCapacity = 0;
        vm.datePickerOpenStatus = {
            departureDate: false
        };
        vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerDepartureDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null
            },
            closed: function(args) {
            }
        };

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.filterTakeoffCapacity = {
            departureDate : new Date()
        }

        vm.formFlights = {
            'departureFlights': [],
            'segmentFlights': []
        };

        vm.eventFlights = function(){
            if (vm.filterTakeoffCapacity.departureDate != undefined) {
                vm.flights = [];
                flightService.getFlightsFromDate(vm.filterTakeoffCapacity.departureDate.getTime())
                    .then(function (response) {
                        var auxFlights = (response.data._embedded) ? response.data._embedded.flights : [];
                        angular.forEach(auxFlights, function (flight) {
                            vm.flights.push({
                                flightNumber: flight.flightNumber,
                                flightId: linkService.getLinkId(flight._links.self.href),
                                route: flight._embedded.route.initials
                            });
                        });
                    });
            }
        }

        vm.eventFlights();

        vm.generate = function () {
            vm.isReport = false;
            vm.formFlights = {
                'departureFlights': [],
                'segmentFlights': []
            };
            vm.editIndexX = -1;
            if (vm.filterTakeoffCapacity.flight) {
                takeoffCapacityService.getTakeoffCapacityByFlightNumber(vm.filterTakeoffCapacity.flight.flightId)
                    .then(function (response) {
                        if (response) {
                            vm.isReport = true;
                            vm.formFlights = response.data;
                            for (var j = 0; j < vm.formFlights.departureFlights.length; j++) {
                                vm.formFlights.departureFlights[j].disabled = true;
                                vm.formFlights.departureFlights[j].showEdit = true;
                                vm.formFlights.departureFlights[j].showSave = false;
                            }

                            for (var i = 0; i < vm.formFlights.segmentFlights.length; i++) {
                                vm.formFlights.segmentFlights[i].auxTakeoffCapacity = angular.copy(vm.formFlights.segmentFlights[i].takeoffCapacity);
                            }
                        }
                    });
            }
        }

        vm.getPos = function(takeoffCapacity, departureFlights) {
            var res = -1;
            for (var i=0; i < departureFlights.length; i++) {
                if (takeoffCapacity < departureFlights[i].takeoffCapacity) {
                    res = i;
                    break;
                }
            }
            return res;
        }

        vm.editTakeoffCapacity = function (indexX) {
            if (vm.editIndexX == indexX || vm.editIndexX == -1) {
                vm.formFlights.departureFlights[indexX].disabled = false;
                vm.formFlights.departureFlights[indexX].showEdit = false;
                vm.editIndexX = indexX;
                vm.auxTakeoffCapacity = angular.copy(vm.formFlights.departureFlights[indexX].takeoffCapacity);
            }
        }

        vm.cancelTakeoffCapacity = function (indexX) {
            vm.formFlights.departureFlights[indexX].disabled = true;
            vm.formFlights.departureFlights[indexX].showEdit = true;
            vm.editIndexX = -1;
            vm.formFlights.departureFlights[indexX].takeoffCapacity = vm.auxTakeoffCapacity;
            vm.auxTakeoffCapacity = 0;
            for (var i = 0; i < vm.formFlights.segmentFlights.length; i++) {
                vm.formFlights.segmentFlights[i].takeoffCapacity = vm.formFlights.segmentFlights[i].auxTakeoffCapacity;
                vm.formFlights.segmentFlights[i].changeColor = false;
            }
        }

        vm.updateSegment = function(pos) {
            if (vm.formFlights.departureFlights[pos].takeoffCapacity == undefined) {
                for (var i = 0; i < vm.formFlights.segmentFlights.length; i++) {
                    vm.formFlights.segmentFlights[i].takeoffCapacity = vm.formFlights.segmentFlights[i].auxTakeoffCapacity;
                    vm.formFlights.segmentFlights[i].changeColor = false;
                }
            } else {
                for (var i = 0; i < vm.formFlights.segmentFlights.length; i++) {
                    var hasDepartureFlightId = false;
                    vm.formFlights.segmentFlights[i].changeColor = false;
                    var minor = angular.copy(vm.formFlights.departureFlights[pos].takeoffCapacity);
                    for (var j = 0; j < vm.formFlights.segmentFlights[i].departureFlights.length; j++) {
                        if (vm.formFlights.segmentFlights[i].departureFlights[j].takeoffCapacity < minor) {
                            if (vm.formFlights.departureFlights[pos].departureFlightId != vm.formFlights.segmentFlights[i].departureFlights[j].departureFlightId) {
                                minor = vm.formFlights.segmentFlights[i].departureFlights[j].takeoffCapacity;
                            }
                        }

                        if (vm.formFlights.departureFlights[pos].departureFlightId == vm.formFlights.segmentFlights[i].departureFlights[j].departureFlightId) {
                            hasDepartureFlightId = true;
                        }
                    }
                    if (hasDepartureFlightId) {
                        if (minor == vm.formFlights.segmentFlights[i].auxTakeoffCapacity) {
                            vm.formFlights.segmentFlights[i].takeoffCapacity = vm.formFlights.segmentFlights[i].auxTakeoffCapacity;
                        } else {
                            vm.formFlights.segmentFlights[i].changeColor = true;
                            vm.formFlights.segmentFlights[i].takeoffCapacity = minor;
                        }
                    }
                }
            }
        }

        vm.saveFlight = function (valid, indexX) {
            if (valid) {
                var rbcFlight = {
                    'departureFlight': {
                        'departureFlightId' : 0,
                        'takeoffCapacity' : 0
                    },
                    'segmentFlights': []
                };

                if (vm.formFlights.departureFlights[indexX].takeoffCapacity != undefined) {
                    rbcFlight.departureFlight.departureFlightId = vm.formFlights.departureFlights[indexX].departureFlightId;
                    rbcFlight.departureFlight.takeoffCapacity = vm.formFlights.departureFlights[indexX].takeoffCapacity;
                    for (var i = 0; i < vm.formFlights.segmentFlights.length; i++) {
                        if (vm.formFlights.segmentFlights[i].changeColor) {
                            var segmentFlight = {
                                'segmentFlightId' : vm.formFlights.segmentFlights[i].segmentFlightId,
                                'takeoffCapacity' : vm.formFlights.segmentFlights[i].takeoffCapacity
                            }
                            rbcFlight.segmentFlights.push(segmentFlight);
                        }
                    }
                    takeoffCapacityService.updateTakeoffCapacity(vm.filterTakeoffCapacity.flight.flightId, rbcFlight)
                        .then(function (res) {
                            vm.generate();
                        });
                }
            }
        }
    }
})();
